import React, { Component } from 'react';
import uuidv4 from 'uuid/v4';
import { Segment, Input, Button } from 'semantic-ui-react';
import firebase from '../../firebase';
import FileModal from './FileModal';
import ProgressBar from './ProgressBar';

export default class MessageForm extends Component {
	state = {
		message: '',
		channel: this.props.currentChannel,
		user: this.props.currentUser,
		loading: false,
		errors: [],
		modal: false,
		uploadState: '',
		uploadTask: null,
		storageRef: firebase.storage().ref(),
		percentUploaded: 0,
	};

	openModal = () => this.setState({ modal: true });
	closeModal = () => this.setState({ modal: false });

	createMessage = (fileUrl = null) => {
		const message = {
			timestamp: firebase.database.ServerValue.TIMESTAMP,
			user: {
				id: this.state.user.uid,
				name: this.state.user.displayName,
				avatar: this.state.user.photoURL,
			},
		};
		if (fileUrl !== null) {
			message['image'] = fileUrl;
		} else {
			message['content'] = this.state.message;
		}
		return message;
	};

	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};
	sendMessage = () => {
		const { getMessagesRef } = this.props;
		const { message, channel } = this.state;

		if (message) {
			this.setState({ loading: true });
			getMessagesRef()
				.child(channel.id)
				.push()
				.set(this.createMessage())
				.then(() => {
					this.setState({
						loading: false,
						message: '',
						errors: [],
					});
				})
				.catch((err) => {
					console.error(err);
					this.setState({
						landing: false,
						errors: this.state.errors.concat(err),
					});
				});
		} else {
			this.setState({
				errors: this.state.errors.concat({ message: 'Add a message' }),
			});
		}
	};

	getPath = () => {
		if (this.props.isPrivateChannel) {
			return `chat/private-${this.state.channel.id}`;
		} else {
			return 'chat/public';
		}
	};

	uploadFile = (file, metadata) => {
		const pathToUpload = this.state.channel.id;
		const ref = this.props.getMessagesRef();
		const filePath = `${this.getPath()}/${uuidv4()}.jpg`;

		this.setState(
			{
				uploadState: 'uploading',
				uploadTask: this.state.storageRef.child(filePath).put(file, metadata),
			},
			() => {
				this.state.uploadTask.on(
					'state_changed',
					(snap) => {
						const percentUploaded = Math.round(
							(snap.bytesTransferred / snap.totalBytes) * 100
						);
						this.props.isProgressBarVisible(percentUploaded);
						this.setState({ percentUploaded });
					},
					(err) => {
						console.error(err);
						this.setState({
							errors: this.state.errors.concat(err),
							uploadState: 'error',
							uploadTask: null,
						});
					},
					() => {
						this.state.uploadTask.snapshot.ref
							.getDownloadURL()
							.then((downloadUrl) => {
								this.sendFileMessage(downloadUrl, ref, pathToUpload);
							})
							.catch((err) => {
								console.error(err);
								this.setState({
									errors: this.state.errors.concat(err),
									uploadState: 'error',
									uploadTask: null,
								});
							});
					}
				);
			}
		);
	};

	sendFileMessage = (fileUrl, ref, pathToUpload) => {
		ref
			.child(pathToUpload)
			.push()
			.set(this.createMessage(fileUrl))
			.then(() => {
				this.setState({
					uploadState: 'done',
				});
			})
			.catch((err) => {
				console.error(err);
				this.setState({
					errors: this.state.errors.concat(err),
				});
			});
	};
	render() {
		const {
			errors,
			message,
			loading,
			modal,
			percentUploaded,
			uploadState,
		} = this.state;
		return (
			<Segment className='message__form'>
				<Input
					fluid
					name='message'
					onChange={this.handleChange}
					value={message}
					style={{ marginBottom: '0.7rem' }}
					label={<Button icon={'add'} />}
					labelPosition='left'
					className={
						errors.some((error) => error.message.includes('message'))
							? 'error'
							: ''
					}
					placeholder='Write Your Message'
				/>

				<Button.Group icon width='3'>
					<Button
						color='orange'
						onClick={this.sendMessage}
						disabled={loading}
						content='Add Reply'
						labelPosition='left'
						icon='edit'
					/>
					<Button
						color='teal'
						content='Upload Media'
						onClick={this.openModal}
						disabled={uploadState === 'uploading'}
						labelPosition='left'
						icon='cloud upload'
					/>
				</Button.Group>
				<FileModal
					modal={modal}
					closeModal={this.closeModal}
					uploadFile={this.uploadFile}
				/>
				<ProgressBar
					uploadState={uploadState}
					percentUploaded={percentUploaded}
				/>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Messages/MessageForm.js